<template>
    <div>
        <dv-full-screen-container class="bg">

            <div class="d-flex flex-row mb-3 justify-content-start align-items-center w-100"
                 style="height: 8%" @click="switchScreenFull">
                <dv-decoration-6 style="width:20%;height:60%;"/>
                <dv-decoration-11 class="dv-card-title h-100" style="width:60%;font-size: 2rem">
                    <dv-decoration-9 style="width:45px;height:45px;"></dv-decoration-9>&nbsp;
                    全面设备效率看板 Overall Equipment Efficiency&nbsp;&nbsp;
                    <p class="dv-card-title" style="font-size: 1.6rem;color: #08e5ff">
                        {{ datetime.substring(0, 11) }}</p>
                    <p class="dv-card-title p-2" style="font-size: 1.6rem;color: #08e5ff">{{
                            datetime.substring(11, 19)
                        }}</p>
                </dv-decoration-11>
                <dv-decoration-6 :reverse="true" style="width:20%;height:60%;"/>

            </div>

            <div class="row" style="height: 92%;margin: 5px 30px;">

                <div class="col-12 h-5">
                    <div class="row d-flex justify-content-around" style="height: 100%">
                        <div class="col-1 h-100 decorative-text"
                             style="display: flex; flex-direction: column; justify-content: center;">
                            <router-link to="/em?menuId=15752&pathType=" class="return-button">
                                <i class="el-icon-arrow-left"></i> 返 回
                            </router-link>
                        </div>
                        <div class="col-1 h-100 decorative-text"
                             style="display: flex; flex-direction: column; justify-content: center;">
                            <el-date-picker v-model="queryDate" type="date"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="统计日期"
                                            style="width: 100%;">
                            </el-date-picker>
                        </div>
                        <div class="col-4 h-100 decorative-text"
                             style="display: flex; flex-direction: column; justify-content: center;">
                            每日部门效率<br>Daily Department Efficiency
                        </div>
                        <div class="col-3 h-100 decorative-text"
                             style="display: flex; flex-direction: column; justify-content: center;">
                            每月设备效率<br>Monthly Equipment Efficiency
                        </div>
                        <div class="col-3 h-100 decorative-text"
                             style="display: flex; flex-direction: column; justify-content: center;">
                            每日设备效率<br>Daily Equipment Efficiency
                        </div>
                    </div>
                </div>
                <div class="col-12 h-95">

                    <div class="row d-flex justify-content-around" style="height: 100%;margin-top: 20px;">
                        <div class="col-2 h-96">
                            <OeeDailyCount style="height: 100%" :id="oeeDailyCountId1" :queryDate="queryDate"
                                           :queryType="queryTypeParts"></OeeDailyCount>
                        </div>
                        <div class="col-2 h-96">
                            <OeeDailyCount style="height: 100%" :id="oeeDailyCountId2" :queryDate="queryDate"
                                           :queryType="queryTypeRotor"></OeeDailyCount>
                        </div>
                        <div class="col-2 h-96">
                            <OeeDailyCount style="height: 100%" :id="oeeDailyCountId3" :queryDate="queryDate"
                                           :queryType="queryTypeCasing"></OeeDailyCount>
                        </div>
                        <div class="col-3 h-96 dashed-line">
                            <OeeDeviceCount style="height: 100%" :id="oeeDeviceCountId1" :queryDate="queryDate"
                                            :queryType="queryTypeMonthly"></OeeDeviceCount>
                        </div>
                        <div class="col-3 h-96">
                            <OeeDeviceCount style="height: 100%" :id="oeeDeviceCountId2" :queryDate="queryDate"
                                            :queryType="queryTypeDaily"></OeeDeviceCount>
                        </div>
                    </div>
                </div>

            </div>

        </dv-full-screen-container>
    </div>
</template>

<script>

import screenfull from 'screenfull'
import EmCommonApi from "@/mixin/em/common/api";
import moment from "moment";
import OeeDailyCount from "@/components/echarts-part/tpm/oee/charts/OeeDailyCount.vue";
import OeeDeviceCount from "@/components/echarts-part/tpm/oee/charts/OeeDeviceCount.vue";

export default {
    name: "OeeLayout",
    mixins: [EmCommonApi],
    components: {
        OeeDeviceCount,
        OeeDailyCount,
    },
    data() {
        return {
            datetime: '',
            rateConfig: {},
            planHour: 0,
            workHour: 0,
            finishPlanHour: 0,
            currentWorkshop: 0,
            wsEnable: [true, true, true, true],
            indicatorPosition: '',
            arrow: 'hover',
            workshopCodeIndex: 0,
            refresh: {
                everySecond: {},
                everyHour: {},
                atTwoClock: {}
            },
            vIfLazyLoad: false,
            pageLoad: true,
            equipmentStatus1: "esParts",
            equipmentStatus2: "esRotors",
            equipmentStatus3: "esCasing",
            queryDate: "",
            queryTypeParts: 1,
            queryTypeRotor: 2,
            queryTypeCasing: 3,
            oeeDailyCountId1: 'oeeDailyCountPart',
            oeeDailyCountId2: 'oeeDailyCountRotor',
            oeeDailyCountId3: 'oeeDailyCountCasing',
            oeeDeviceCountId1: 'oeeMonthlyDeviceCount',
            oeeDeviceCountId2: 'oeeDailyDeviceCount',
            queryTypeMonthly: 1,
            queryTypeDaily: 2,
        }
    },
    created() {
        if (!screenfull.isFullscreen) {
            screenfull.toggle()
        }
    },
    mounted() {
        this.fnResize()
        window.addEventListener('resize', this.fnResize, false)
        //this.getSafetyDate()

        this.intervals()
        setTimeout(() => this.vIfLazyLoad = true, 2000);
        //this.subscribeChannels();//订阅
    },
    beforeDestroy() {
        //2024.4.10 屏蔽强制刷新，在SITH新电视（小米EA65）无法调试不明原因刷新就卡死，每天晚上要关机，所以没必要定时强制刷新了
        this.clearIntervals()
        window.removeEventListener('resize', this.fnResize, false)
        document.documentElement.style.fontSize = '16px';

        // 退出页面前，退出全屏
        if (screenfull.isFullscreen) {
            screenfull.exit();
        } else if (document.fullscreenElement) {
            document.exitFullscreen();
        }
    },

    methods: {
        intervals() {
            this.refresh.everySecond = setInterval(() => {
                this.datetime = moment(new Date()).format(this.$t("em.datetime.format.viewMode"))
            }, 1000);

            // this.refresh.everyHour = setInterval(() => {
            //     //this.getSafetyDate()
            //
            //     console.clear();//clear logs every hour
            // }, 3600 * 1000);

            //2024.4.10 屏蔽强制刷新，在SITH新电视（小米EA65）无法调试不明原因刷新就卡死，每天晚上要关机，所以没必要定时强制刷新了
            // this.refresh.atTwoClock = setInterval(() => {
            //     const now = new Date();
            //     if (now.getHours() === 2 && now.getMinutes() === 0) {
            //         this.reloadPage();
            //     }
            // }, 20000);
        },
        clearIntervals() {
            clearInterval(this.refresh.everySecond);
            clearInterval(this.refresh.everyHour);
            clearInterval(this.refresh.atTwoClock);
        },

        switchScreenFull() {
            screenfull.toggle();
            this.fnResize()
        },

        fnResize() {
            let deviceWidth = document.documentElement.clientWidth || window.innerWidth;
            document.documentElement.style.fontSize = (deviceWidth / 125) + 'px';
        },
        carousel(index) {
            this.currentWorkshop = index
        },
        reloadPage() {
            this.$emit('needReload');
        },
    }
}
</script>

<style scoped>
.bg {
    background-color: #1B1534;
    padding: 0.2rem 0.2rem 0 0.2rem;
    background-image: url("../../../../assets/images/emKpi/oeeBack1.jpg");
    background-size: cover;
    background-position: center center;
}

.dv-card-title {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 1.5rem;
    color: #7ec699;
    font-weight: 700;
    margin: auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.date-card {
    background-color: rgba(4, 49, 128, .6);
    height: 5.5rem;
    width: 5.5rem;
    margin: auto;
    padding: 0
}

.date-card-number {
    color: #08e5ff;
    font-size: 2.8rem;
    font-weight: bold;
    text-align: center;
    margin: 0.5rem
}

.numbers {
    position: relative;
    overflow: hidden;
    border-radius: 0.375rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00ffc4;
    font-weight: 700;
    font-size: 1.5rem;
    margin: auto;
}

.fill {
    width: 100%;
    height: 100%;
}

.w-100 >>> text {
    font-size: 1.6rem;
}

.float-above {
    position: absolute;
    z-index: 9999;
}

.p1 {
    left: 2rem;
    top: 1rem;
    color: #7ec699;
    font-size: 2rem !important;
}

.p2 {
    right: 1rem;
    bottom: 0;
    color: #1294fb;
    font-size: 1rem
}

.svg-cover {

}

.dv-card-title.title-a {
    font-size: 1.2rem;
    color: white;
}

.number-sub {
    color: #6df9c6;
    font-size: 1rem;
    font-weight: bold;
}

.decorative-text {
    font-size: 1.2rem;
    background-color: rgba(255, 255, 255, 0.1); /* 设置背景颜色为绿色 */
    color: white; /* 设置文字颜色为白色 */
    font-weight: bold; /* 设置文字为粗体 */
    border-radius: 10px; /* 设置圆角边框 */
    padding: 5px 15px; /* 设置内边距，根据需要调整 */
    display: inline-block; /* 使元素变成行内块级元素，以适应文本内容 */
    width: 100%;
    text-align: center;
    padding: 0.5rem 1rem;
}

.dashed-line {
    width: 100%; /* 设置元素宽度，可以根据需要调整 */
    height: 1px; /* 设置虚线的高度，可以根据需要调整 */
    background: transparent; /* 透明背景 */
    border-left: 1px dashed #CC66FF; /* 定义虚线样式和颜色 */
    border-width: 3px 5px; /* 第一个值是虚线间隔，第二个值是虚线长度 */
}

.return-button {
    font-size: 0.7rem;
    background-color: #409eff; /* 设置按钮背景颜色 */
    color: #fff; /* 设置文字颜色 */
    padding: 6px 10px; /* 设置内边距 */
    text-decoration: none; /* 去掉下划线 */
    border-radius: 5px; /* 圆角 */
}

.return-button:hover {
    background-color: #66b1ff; /* 鼠标悬停时的颜色 */
    color: #ffffff; /* 设置文字颜色 */
}

/* 设置根元素的字体大小为基准大小 */
html {
    font-size: 16px;
}

/deep/ .el-input__inner {
    height: 2.5rem;
    font-size: 0.8rem;
}


/* 使用 flex 垂直居中 el-date-picker 中的图标 */
/* 隐藏日期选择器的图标 */
/deep/ .el-date-editor .el-input__icon {
    display: none;
}

</style>
